<div class="action-buttons">
  <app-button-filter-table (click)="aplicarFiltro.emit()"></app-button-filter-table>
  <app-button-filter-table-clear (click)="limpiarFiltro.emit()"></app-button-filter-table-clear>

  <button mat-icon-button matTooltip="Filtros avanzados"
          class="small-icon-btn"
          [matMenuTriggerFor]="menuFiltroAvanzado"
          [class.active]="checkedFiltroAvanzado"
          (menuOpened)="menuOpened.emit()"
          (menuClosed)="menuClosed.emit()">
    <mat-icon>tune</mat-icon>
  </button>
</div>
